import { type GameConfigs } from "kadow-jetpack-model";
import React from "react";
import { GameThumbnailDTO } from "../../../../model/GameDTO";
import KC_Card from "../../../../designsystem/KC_Card/KC_Card";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import { KC_Sizes } from "../../../../designsystem/ds_commons";
import GameCardPreview from "../../../../app/23_GameCardPreview/GameCardPreview";
import Carousel from "../../../Carousel/Carousel";
import KC_Separator from "../../../../designsystem/KC_Separator/KC_Separator";
import { getDisplayNameForGameType } from "../../../../utils/helpers/getDisplayNameForGameType";
import { tt } from "../../../../utils/i18n/i18n";

interface GameSelectorContentProps {
  displayedGames: GameThumbnailDTO[];
  isGamesSelectable: boolean;
  onGameSelect: (game: GameThumbnailDTO, isSelected: boolean) => void;
  onSubmit: () => void;
  handleGoBack: () => void;
  submitBtnTitle: string;
  useSubmit: boolean;
  isGameSelected?: (game: GameThumbnailDTO) => boolean;
  noPadding?: boolean;
}

export default function GamesCarousel(props: GameSelectorContentProps) {
  return (
    <div id="game-selector-content" className="mt-4 d-flex flex-column gap-sm">
      <div className="pl-0 pl-sm-4 mb-5">
        <Carousel
          baseId="event-selector"
          slides={props.displayedGames.map((item, idx) => {
            const isSelected = props.isGameSelected?.(item) || false;
            return (
              <div key={idx}>
                <KC_Card
                  id={`game-card-${item.name}`}
                  title={getDisplayNameForGameType(
                    item.name as keyof GameConfigs
                  )}
                  boxShadow={false}
                  image={""}
                  useTwicPics={true}
                  className={`border carousel-slide ${isSelected ? "active" : ""}`}
                  onClick={() => props.onGameSelect(item, isSelected)}
                  isGameCardPreview={true}
                >
                  <GameCardPreview
                    gameCardConfig={item.config}
                    eventId={item.eventId}
                  />
                  <div className="w-100 d-flex justify-content-between">
                    <div className="w-100 d-flex justify-content-between">
                      <KC_Button
                        size={KC_ButtonSize.Large}
                        className={`border d-flex ${isSelected && "selected-btn"}`}
                        isPrimaryLight={isSelected}
                        isInverted={!isSelected}
                        id={`${item.name}-toggle`}
                        type={KC_ButtonType.Button}
                        text={
                          isSelected ? tt("game_selected") : tt("game_select")
                        }
                      />
                    </div>
                  </div>
                </KC_Card>
              </div>
            );
          })}
        />
      </div>
      <KC_Separator size={KC_Sizes.m} />
      <div className="w-100">
        {props.useSubmit && (
          <div className="w-100 d-flex justify-content-end gap-sm border-top p-2">
            <div>
              <KC_Button
                id="add-game-btn"
                type={KC_ButtonType.Button}
                onClick={props.onSubmit}
                isPrimary={true}
                size={KC_ButtonSize.Large}
                text={props.submitBtnTitle}
                className="d-flex"
                disabled={false}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
